import { createSlice } from '@reduxjs/toolkit'

const aiNotetakerBetaSlice = createSlice({
  name: 'aiNotetakerBeta',
  initialState: {
    showModal: false,
  },
  reducers: {
    resetShowAiNotetakerBetaModal: (state) => {
      state.showModal = false
      state.context = null
    },
    setAiNotetakerBetaModalVisible: (state, { payload }) => {
      state.showModal = true
      state.context = payload
    },
  },
})

export const {
  reducer,
  actions: {
    resetShowAiNotetakerBetaModal,
    setAiNotetakerBetaModalVisible
  },
} = aiNotetakerBetaSlice
